import { Timestamp } from 'firebase/firestore'
import { FirebaseProperties } from '../Helper/FirebaseProperties'
import { FirebaseCollections, FirestorePaths } from '@/utils/firestore/FirestorePaths'
import type {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions
} from 'firebase/firestore'
import { createFirebaseInterface } from '../Helper/FirebaseProperties'

export class AlertReceipt extends FirebaseProperties {
  alertId = ''
  storeId = ''
  readAt: Timestamp | null = null
  dismissedAt: Timestamp | null = null
  lastShownAt: Timestamp | null = null
  readVersion: number | null = null
  expiresAt: Timestamp | null = null

  constructor(data?: Partial<AlertReceipt>) {
    super()
    Object.assign(this, data)
    this.setId()
  }

  setId(accountId?: string, alertId?: string) {
    if (!accountId) {
      this.thisCollection = ''
      this.thisDocument = ''
      return
    }

    this.thisCollection = FirestorePaths.nestedCollection(
      FirestorePaths.rootDocument(FirebaseCollections.Accounts, accountId),
      FirebaseCollections.AlertReceipts
    )

    const id = alertId ?? this.firebaseInfo?.__id
    this.thisDocument = id ? `${this.thisCollection}/${id}` : this.thisCollection
  }

  get isRead(): boolean {
    return this.readAt != null
  }

  get isDismissed(): boolean {
    return this.dismissedAt != null
  }
}

export const AlertReceiptConverter: FirestoreDataConverter<AlertReceipt> = {
  toFirestore(receipt: AlertReceipt) {
    return {
      alertId: receipt.alertId,
      storeId: receipt.storeId,
      readAt: receipt.readAt,
      dismissedAt: receipt.dismissedAt,
      lastShownAt: receipt.lastShownAt,
      readVersion: receipt.readVersion ?? null,
      expiresAt: receipt.expiresAt ?? null,

      firebaseInfo: {
        ...receipt.firebaseInfo
      }
    }
  },

  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions) {
    const data = snapshot.data(options)

    return new AlertReceipt({
      ...data,
      firebaseInfo: createFirebaseInterface({
        ...data.firebaseInfo,
        __id: snapshot.id
      })
    })
  }
}
